export const funnelVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard funnel chart with centered trapezoids and labels.',
    overrides: {
      props: {},
      className: null,
      styles: {}
    }
  },
  sharp: {
    code: 'sharp',
    displayName: 'Sharp',
    description: 'Funnel with configurable gap and alignment. Creates a sharper, more geometric look.',
    parameters: [
      {
        key: 'gap',
        type: 'select',
        label: 'Gap',
        default: 0,
        options: [
          { value: 0, label: 'None' },
          { value: 2, label: 'Small' },
          { value: 4, label: 'Medium' },
          { value: 8, label: 'Large' }
        ]
      },
      {
        key: 'funnelAlign',
        type: 'select',
        label: 'Alignment',
        default: 'left',
        options: [
          { value: 'center', label: 'Center' },
          { value: 'left', label: 'Left' },
          { value: 'right', label: 'Right' }
        ]
      }
    ],
    resolve: (params) => ({
      props: {
        gap: params.gap,
        funnelAlign: params.funnelAlign
      },
      className: null,
      tableClassName: null,
      styles: {}
    })
  }
}
